const PENDING_ENT_USER_REQUEST = 'PENDING_ENT_USER_REQUEST';
const PENDING_ENT_USER_SUCCESS = 'PENDING_ENT_USER_SUCCESS';
const PENDING_ENT_USER_FAILURE = 'PENDING_ENT_USER_FAILURE';

export {
  PENDING_ENT_USER_REQUEST,
  PENDING_ENT_USER_SUCCESS,
  PENDING_ENT_USER_FAILURE,
};
